import getPublicEnv from '@utils/getPublicEnv';

export const SEARCH_PRODUCTS_NUMBER = {
  ultrahd: 12,
  fullhd: 12,
  widescreen: 10,
  desktop: 10,
  tabletlg: 8,
  tablet: 8,
  mobilelg: 4,
  mobile: 4,
};

export const SEARCH_PRODUCTS_NUMBER_PER_ROW = {
  ultrahd: 6,
  fullhd: 6,
  widescreen: 5,
  desktop: 5,
  tabletlg: 6,
  tablet: 6,
  mobilelg: 6,
  mobile: 6,
};

export const SEARCH_INDEX = {
  products: process.env.ALGOLIA_PRODUCTS_INDEX || getPublicEnv('NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX'),
  categories: process.env.ALGOLIA_CATEGORIES_INDEX || getPublicEnv('NEXT_PUBLIC_ALGOLIA_CATEGORIES_INDEX'),
  suggestions: process.env.ALGOLIA_SUGGESTIONS_INDEX || getPublicEnv('NEXT_PUBLIC_ALGOLIA_SUGGESTIONS_INDEX'),
  shops: process.env.ALGOLIA_SHOPS_INDEX || getPublicEnv('NEXT_PUBLIC_ALGOLIA_SHOPS_INDEX'),
  ideas: process.env.ALGOLIA_IDEAS_INDEX || getPublicEnv('NEXT_PUBLIC_ALGOLIA_IDEAS_INDEX'),
  projects: process.env.ALGOLIA_PROJECTS_INDEX || getPublicEnv('NEXT_PUBLIC_ALGOLIA_PROJECTS_INDEX'),
};

export const MAX_HITS = 120;

export const SEARCH_DEBOUNCE_TIME = 250;

export const SETP_PRODUCT_RESULT_FOR_DESKTOP = 8;
export const SETP_PRODUCT_RESULT_FOR_TABLET = 6;

export const CLIENT_ID = process.env.ALGOLIA_APP_ID || getPublicEnv('NEXT_PUBLIC_ALGOLIA_APP_ID');
export const CLIENT_KEY = process.env.ALGOLIA_READONLY_API_KEY || getPublicEnv('NEXT_PUBLIC_ALGOLIA_READONLY_API_KEY');
